import {type ProgressDb} from '@cp/model';
import {doc, type DocumentReference} from 'firebase/firestore';
import getProgressCollectionRef from './getProgressCollectionRef';

/**
 * Get the progress document reference for a user and exam module.
 * @param uid - The user id.
 * @param examModuleId - The exam module id.
 * @returns The progress document reference.
 */
export default function getProgressDocRef(uid: string, examModuleId: string): DocumentReference<ProgressDb> {
  return doc(getProgressCollectionRef(uid), examModuleId) as DocumentReference<ProgressDb>;
}
